import React from 'react';

import {REPORT} from '@constants/resources';
import {GetReportIncidentOptions, GetReportAnIncident, GetReports} from '@graphql/reports/query';
import {CreateReport, UpdateReport, DeleteReport} from '@graphql/reports/mutation';
import Form from '@appComponents/ReduxFormControls';
import * as messages from '@constants/messages';
import {IconInfoCircle} from '@appComponents/IconCollection';
import {WORKING_REPORT_TYPE, NOT_STREAMED_REPORT_TYPE} from '@constants/variables';

import validatorEventReportIncident from './validatorEventReportIncident';

function EventReportBasicModel(isEditMode = false, reportType) {
    const getTitleByReportType = (reportType) => {
        switch (reportType) {
            case WORKING_REPORT_TYPE:
                return 'Report as working';
            case NOT_STREAMED_REPORT_TYPE:
                return 'Report as not streamed';
        }
    };

    return {
        title: () => getTitleByReportType(reportType),
        formName: 'distributionReport',
        entityLabel: 'report',
        entityDataMapKey: 'report',
        resources: REPORT,
        showChangeLog: true,
        validate: validatorEventReportIncident,
        label: 'Incident',
        messages: {
            boxName: {
                delete: 'event',
                success: 'event',
                error: 'event',
            },
            text: {
                ...messages,
                DELETE_HEADER_ARGUMENT_FIRST: () => messages.DELETE_HEADER('report'),
            },
        },
        mutation: {
            createEntity: CreateReport,
            updateEntity: UpdateReport,
            deleteEntity: DeleteReport,
        },
        mutationOptions: {
            create: {
                refetchQueries: [GetReports],
            },
            update: {
                refetchQueries: [GetReports],
            },
            delete: {
                refetchQueries: [GetReports],
            },
        },
        query: {
            getEntity: GetReportAnIncident,
            getOptions: GetReportIncidentOptions,
        },
        fields: {
            id: {
                dataMapKey: 'report.id',
                props: {
                    component: Form.IdField,
                    label: '',
                    name: 'id',
                    hidden: true,
                },
            },
            includes_all_streams: {
                dataMapKey: 'report.includes_all_streams',
                props: {
                    component: Form.SemanticInput,
                    label: 'All streams',
                    name: 'includes_all_streams',
                    type: 'toggle',
                    ...(isEditMode ? {} : {defaultValue: (reportType === WORKING_REPORT_TYPE)}),
                    description: <IconInfoCircle
                        tooltip={'Switch on if the report is for all of the streams of the event.'}/>,
                },
            },
            report_scopes: {
                props: {
                    component: Form.SemanticCheckboxTree,
                    label: 'Scope',
                    name: 'report_scopes',
                    returnParsedTreeValues: true,
                    hidden: true,
                    jsxLabelOption: true,
                },
            },
            comment: {
                dataMapKey: 'report.comment',
                props: {
                    component: Form.SemanticTextArea,
                    label: 'Comment',
                    name: 'comment',
                    rows: 3,
                },
            },
        },
    };
}

export function EventReportBasicAddModel(reportType) {
    return EventReportBasicModel(false, reportType);
}

export function EventReportBasicEditModel(reportType) {
    return EventReportBasicModel(true, reportType);
}
